import { CHART_CONFIG } from '../../config/chart-config';
import { getChartPlaceholderText, hasChartData } from '../../helpers/domain';
import ChartPlaceholder from './charts/placeholders/ChartPlaceholder';

const ChartRenderer = ({ data, type, context, title: titleOverride = null }) => {
    if (!CHART_CONFIG[type]) return null;

    const config = CHART_CONFIG[type];

    const { Component: ChartComponent, title, variant = 'chart', extraProps = {} } = config;

    const resolvedTitle = titleOverride ?? title;

    if (hasChartData(data)) return <ChartComponent {...data} {...extraProps} title={resolvedTitle} />;

    return (
        <ChartPlaceholder
            title={resolvedTitle}
            variant={variant}
            text={getChartPlaceholderText(type, context)}
        />
    );
};

export default ChartRenderer;
